import { render, staticRenderFns } from "./CampaignView.vue?vue&type=template&id=06df5922"
import script from "./CampaignView.vue?vue&type=script&lang=js"
export * from "./CampaignView.vue?vue&type=script&lang=js"
import style0 from "./CampaignView.vue?vue&type=style&index=0&id=06df5922&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports